import { gql } from '@apollo/client';

/**
 * ТЗ 0074 (доработка) — LMS suspension settings on «Ustawienia platformy».
 * Operation names deliberately differ from the backend field names (codegen
 * result-type collapse otherwise). The settings field set is written out in
 * full in each operation — codegen silently skips interpolated documents.
 */

export const LmsBlockSettingsViewQuery = gql`
  query LmsBlockSettingsView {
    lmsBlockSettings {
      robotEnabled
      overdueDays
      mailEnabled
      slackEnabled
      smsEnabled
      suspendedTemplateId
      suspendedTemplateName
      restoredTemplateId
      restoredTemplateName
      updatedAt
      updatedByName
      serverRobotAllowed
      serverMailAllowed
      serverSlackAllowed
      serverSmsAllowed
      canEdit
    }
  }
`;

export const LmsBlockTemplatePickerQuery = gql`
  query LmsBlockTemplatePicker {
    lmsBlockSendgridTemplates {
      success
      templates {
        id
        name
        subject
        versionId
        updatedAt
      }
      customErrors {
        field
        code
        message
      }
    }
  }
`;

export const LmsBlockTemplateVariablesListQuery = gql`
  query LmsBlockTemplateVariablesList {
    lmsBlockTemplateVariables {
      name
      type
      descriptionPl
      descriptionRu
      example
      fields {
        name
        type
        descriptionPl
        descriptionRu
        example
      }
    }
  }
`;

export const LmsBlockTemplateExampleDataQuery = gql`
  query LmsBlockTemplateExampleData($kind: String!) {
    lmsBlockTemplateExample(kind: $kind)
  }
`;
